import { useLocation, useNavigate } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import ProductCategories from "@/pages/ProductCategories";
import ProductCatalog from "@/pages/ProductCatalog";

export default function Product() {
  const location = useLocation();
  const navigate = useNavigate();
  const activeTab = location.pathname.endsWith("/products") ? "products" : "categories";

  return (
    <div className="space-y-8" data-testid="product-page">
      <div>
        <div className="label-mini">Product</div>
        <h1 className="mt-1 font-heading text-4xl font-black tracking-tight">Product Catalog</h1>
      </div>
      <Tabs value={activeTab} onValueChange={(value) => navigate(`/products/${value}`)}>
        <TabsList>
          <TabsTrigger value="categories" data-testid="categories-tab">Category</TabsTrigger>
          <TabsTrigger value="products" data-testid="products-tab">Product</TabsTrigger>
        </TabsList>
        <TabsContent value="categories" className="mt-6">
          <ProductCategories embedded />
        </TabsContent>
        <TabsContent value="products" className="mt-6">
          <ProductCatalog embedded />
        </TabsContent>
      </Tabs>
    </div>
  );
}